import { isMobileRoute } from './isMobileRoute';
import { type DevicePlatform } from './types';

export const resolveMobileView = (params: { devicePlatform: DevicePlatform; pathname: string }): boolean =>
    params.devicePlatform === 'mobile' && isMobileRoute(params.pathname);

type ResolveEffectivePlatformParams = Parameters<typeof resolveMobileView>[0] & {
    forceDesktop?: boolean;
};

export const resolveEffectivePlatform = (params: ResolveEffectivePlatformParams): DevicePlatform => {
    if (params.forceDesktop) {
        return 'desktop';
    }

    return resolveMobileView(params) ? 'mobile' : 'desktop';
};
